/**
 * Currency configuration for supported currencies
 */
const CURRENCY_CONFIG: Record<string, { locale: string; step: string; placeholder: string; name: string }> = {
  VND: { locale: 'vi-VN', step: '1000', placeholder: '350000', name: 'Vietnamese Dong' },
  USD: { locale: 'en-US', step: '0.01', placeholder: '10.00', name: 'US Dollar' },
  EUR: { locale: 'de-DE', step: '0.01', placeholder: '10.00', name: 'Euro' },
  GBP: { locale: 'en-GB', step: '0.01', placeholder: '10.00', name: 'British Pound' },
  JPY: { locale: 'ja-JP', step: '1', placeholder: '1000', name: 'Japanese Yen' },
  KRW: { locale: 'ko-KR', step: '100', placeholder: '10000', name: 'South Korean Won' },
  CNY: { locale: 'zh-CN', step: '0.01', placeholder: '10.00', name: 'Chinese Yuan' },
  THB: { locale: 'th-TH', step: '0.01', placeholder: '100.00', name: 'Thai Baht' },
  SGD: { locale: 'en-SG', step: '0.01', placeholder: '10.00', name: 'Singapore Dollar' },
  MYR: { locale: 'ms-MY', step: '0.01', placeholder: '10.00', name: 'Malaysian Ringgit' },
  PHP: { locale: 'fil-PH', step: '0.01', placeholder: '100.00', name: 'Philippine Peso' },
  IDR: { locale: 'id-ID', step: '100', placeholder: '100000', name: 'Indonesian Rupiah' },
  INR: { locale: 'en-IN', step: '0.01', placeholder: '100.00', name: 'Indian Rupee' },
  AUD: { locale: 'en-AU', step: '0.01', placeholder: '10.00', name: 'Australian Dollar' },
  NZD: { locale: 'en-NZ', step: '0.01', placeholder: '10.00', name: 'New Zealand Dollar' },
  CAD: { locale: 'en-CA', step: '0.01', placeholder: '10.00', name: 'Canadian Dollar' },
}

/**
 * List of supported currency codes for use in dropdowns
 */
export const SUPPORTED_CURRENCIES = Object.keys(CURRENCY_CONFIG)

/**
 * Get human-readable name for a currency code
 */
export function getCurrencyName(currency: string): string {
  return CURRENCY_CONFIG[currency]?.name || currency
}

/**
 * Get the currency configuration for a given currency code
 */
export function getCurrencyConfig(currency: string) {
  return CURRENCY_CONFIG[currency] || CURRENCY_CONFIG.USD
}

/**
 * Format a price according to the organization's currency
 */
export function formatPrice(price: string | null | undefined, currency: string): string | null {
  if (!price) return null
  const num = parseFloat(price)
  const config = getCurrencyConfig(currency)
  return new Intl.NumberFormat(config.locale, {
    style: 'currency',
    currency: currency,
  }).format(num)
}

/**
 * Get the step value for price inputs based on currency
 */
export function getPriceInputStep(currency: string): string {
  return getCurrencyConfig(currency).step
}

/**
 * Get a placeholder value for price inputs based on currency
 */
export function getPricePlaceholder(currency: string): string {
  return getCurrencyConfig(currency).placeholder
}
